import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IWorkshopTagGroupScheme } from '../types/WorkshopTagGroupScheme';

const initialState: IWorkshopTagGroupScheme = {
	currentTagsIds: [],
	deletingGroupId: undefined,
	editGroupName: undefined,
	editingGroupId: undefined,

	isDeleteGroupModalActive: false,
	openedGroupsIds: [],
	isEditingGroupModalActive: false,

	createdGroupTags: [],
	createGroupName: undefined,

	bindingGroupId: undefined,
	bindingTags: [],
	isBindingGroupModalActive: false,

	unbindingGroupId: undefined,
	unbindingTags: [],
	isUnbindingGroupModalActive: false,
	deleteTagGroupFn: null,

	modalsActive: {
		isEditingGroupModalActive: false,
		isDeleteGroupModalActive: false,
		isCreateGroupModalActive: false,
		isBindingGroupModalActive: false,
		isUnbindingGroupModalActive: false,
	},
};

export const workshopModuleTagGroupSlice = createSlice({
	name: 'workshopModuleTagGroup',
	initialState,
	selectors: {
		getOpenedGroupsIds: (state) => state.openedGroupsIds,
		getIsCreateGroupModalActive: (state) => state.modalsActive.isCreateGroupModalActive,
		getIsDeleteGroupModalActive: (state) => state.modalsActive.isDeleteGroupModalActive,
		getIsEditingGroupModalActive: (state) => state.modalsActive.isEditingGroupModalActive || false,
		getDeletingGroupId: (state) => state.deletingGroupId,
		getEditingGroupId: (state) => state.editingGroupId,
		getCreateGroupName: (state) => state.createGroupName || '',
		getEditGroupName: (state) => state.editGroupName || '',
		getCreatedGroupTags: (state) => state.createdGroupTags || [],
		getBindingGroupId: (state) => state.bindingGroupId,
		getBindingTags: (state) => state.bindingTags || [],
		getIsBindingGroupModalActive: (state) => state.modalsActive.isBindingGroupModalActive || false,
		getUnbindingGroupId: (state) => state.unbindingGroupId,
		getUnbindingTags: (state) => state.unbindingTags || [],
		getIsUnbindingGroupModalActive: (state) => state.isUnbindingGroupModalActive || false,
	},
	reducers: {
		setCurrentTagsIds: (state, action: PayloadAction<number[]>) => {
			state.currentTagsIds = action.payload;
		},
		setIsCreateGroupModalActive(state, action: PayloadAction<boolean>) {
			state.modalsActive.isCreateGroupModalActive = action.payload;
		},
		setIsDeleteGroupModalActive(state, action: PayloadAction<boolean>) {
			state.modalsActive.isDeleteGroupModalActive = action.payload;
		},
		setIsEditingGroupModalActive(state, action: PayloadAction<boolean>) {
			state.modalsActive.isEditingGroupModalActive = action.payload;
		},
		addCreatedGroupTag(state, action: PayloadAction<number>) {
			state.createdGroupTags.push(action.payload);
		},
		removeCreatedGroupTag(state, action: PayloadAction<number>) {
			state.createdGroupTags = state.createdGroupTags.filter((tag) => tag !== action.payload);
		},
		setCreatedGroupTags(state, action: PayloadAction<number[]>) {
			state.createdGroupTags = action.payload;
		},
		setDeletingGroupId(state, action: PayloadAction<string>) {
			state.deletingGroupId = action.payload;
		},
		setEditingGroupId(state, action: PayloadAction<string | undefined>) {
			state.editingGroupId = action.payload;
		},
		setCreateGroupName(state, action: PayloadAction<string>) {
			state.createGroupName = action.payload;
		},
		setEditGroupName(state, action: PayloadAction<string>) {
			state.editGroupName = action.payload;
		},
		setBindingGroupId(state, action: PayloadAction<string | undefined>) {
			state.bindingGroupId = action.payload;
		},
		setBindingTags(state, action: PayloadAction<number[]>) {
			state.bindingTags = action.payload;
		},
		setIsBindingGroupModalActive(state, action: PayloadAction<boolean>) {
			state.modalsActive.isBindingGroupModalActive = action.payload;
		},
		setUnbindingGroupId(state, action: PayloadAction<string | undefined>) {
			state.unbindingGroupId = action.payload;
		},
		setUnbindingTags(state, action: PayloadAction<number[]>) {
			state.unbindingTags = action.payload;
		},
		setIsUnbindingGroupModalActive(state, action: PayloadAction<boolean>) {
			state.modalsActive.isUnbindingGroupModalActive = action.payload;
		},
		setOpenedGroupsIds(state, action: PayloadAction<string>) {
			const index = state.openedGroupsIds.indexOf(action.payload);
			if (index !== -1) {
				// Удаляем id из массива открытых окон
				state.openedGroupsIds.splice(index, 1);
			} else {
				state.openedGroupsIds.push(action.payload);
			}
		},
		setDeleteTagGroupFn(state, action: PayloadAction<() => void>) {
			state.deleteTagGroupFn = action.payload;
		},
	},
});

export const {
	actions: workshopModuleTagGroupActions,
	reducer: workshopModuleTagGroupReducer,
	selectors: workshopModuleTagGroupSelectors,
} = workshopModuleTagGroupSlice;
